/**
 * Entity name of a calculation definition. The route segment is `snakeCaseName()` of it,
 * `calculation-definition`.
 */
export const CALCULATION_DEFINITION_ENTITY_NAME = 'Calculation Definition';
